module.exports = __webpack_public_path__ + "static/media/15. Speaker Edgardo S. Luzano.8dd60815.png";